import { render, staticRenderFns } from "./CalculateMassivePickupsModal.vue?vue&type=template&id=6c05017e&"
import script from "./CalculateMassivePickupsModal.vue?vue&type=script&lang=js&"
export * from "./CalculateMassivePickupsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports